export default {
  Login: {
    Layer: 'Website.Login',
    Parameters: ['CrossDeviceButtonText']
  },
  InvalidCredentials: {
    Layer: 'Website.Login.InvalidCredentials',
    Parameters: ['CrossDeviceLoginFailLimit', 'CrossDeviceLoginFailErrorText']
  }
};
